import { combineReducers } from "redux";
import propertyReducer from "./propertyReducer";
import coreReducer from "./coreReducer";
import searchReducer from "./searchReducer";
import stateReducer from "./stateReducer";

const rootReducer = combineReducers({
  properties: propertyReducer,
  core: coreReducer,
  search: searchReducer,
  property: propertyReducer,
  cart: stateReducer,
  reviews: propertyReducer,
});

export default rootReducer;
